module.exports = __webpack_public_path__ + "img/thumbnail_RedFox_j_melanistic.824b7f5d.png";